import {
  FetchResult,
  fromPromise,
  Observable,
  ServerError,
} from "@apollo/client";
import { ErrorLink, ErrorResponse } from "@apollo/client/link/error";
import { HTTP_STATUS_UNAUTHORIZED } from "@/constants/http.constants";
import { RefreshToken } from "@/providers/AuthenticationProvider/AuthenticationProvider.decl";

const noop = () => {};

/**
 * Handle error if api request fails
 */
export const onRequestError =
  (logoutHandler: VoidFunction, refreshToken: RefreshToken) =>
  ({
    networkError,
    operation,
    forward,
  }: ErrorResponse): Observable<FetchResult> | void => {
    const has401Error =
      networkError &&
      (networkError as ServerError).statusCode === HTTP_STATUS_UNAUTHORIZED;
    const hasUnauthorizedException =
      networkError &&
      JSON.stringify(networkError).includes("UnauthorizedException");

    if (has401Error || hasUnauthorizedException) {
      return fromPromise(
        refreshToken()
          .then(() => {
            return true;
          })
          .catch(() => {
            // Clear all stored tokens, which will force user to logout
            logoutHandler();
          })
      )
        .filter((value) => Boolean(value))
        .flatMap(() =>
          // when refreshing token succeeds, retry the request, return the new observable
          forward(operation)
        );
    }
    return noop();
  };

export const errorLink = (
  logoutHandler: VoidFunction,
  refreshTokenHandler: RefreshToken
): ErrorLink =>
  new ErrorLink(onRequestError(logoutHandler, refreshTokenHandler));
